module.exports = __webpack_public_path__ + "media/images/smart_phone/products/kamasu2-4894458360341acc3aef13bb059d4f19.jpeg";